import {createStore, applyMiddleware} from 'redux'
import reducers from './reducers'
import logger from 'redux-logger'

import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import createSagaMiddleware from 'redux-saga'
import mySaga from './saga'

const sagaMiddleware = createSagaMiddleware()

const persistConfig = {
    key: 'root',
    blacklist: ['generalState'],
    storage,
  }

const persistedReducer = persistReducer(persistConfig, reducers)

// export const store = createStore(persistedReducer,applyMiddleware(sagaMiddleware,logger));
export const store = createStore(persistedReducer,applyMiddleware(sagaMiddleware));

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch


sagaMiddleware.run(mySaga);

